<template>
  <div class="min-h-screen bg-slate-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <Head title="Consultar Estado de Cuenta - Condominio" />

    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <!-- Logo Header -->
      <div class="flex justify-center mb-6">
        <logo :src="logo" class="h-12 w-auto object-contain" />
      </div>
      <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
        Portal de Propietarios
      </h2>
      <p class="mt-2 text-center text-sm text-gray-600 max-w-sm mx-auto">
        Consulta el estado de cuenta de tu inmueble de forma inmediata y reporta tus pagos en línea.
      </p>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md px-4">
      <div class="bg-white py-8 px-6 shadow-md border border-slate-200 rounded-xl">
        
        <!-- Explanation Alert Box -->
        <div class="mb-6 p-4 rounded-lg bg-indigo-50 border border-indigo-100">
          <div class="flex">
            <div class="flex-shrink-0">
              <svg class="h-5 w-5 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div class="ml-3">
              <h3 class="text-sm font-bold text-indigo-900">¿Cómo consultar tu cuenta?</h3>
              <p class="mt-1 text-xs text-indigo-700 leading-relaxed">
                Ingresa la **Cédula de Identidad** o el **Alias / Apartado** de propietario asignado por la junta de condominio para ver tu balance y cuotas pendientes.
              </p>
            </div>
          </div>
        </div>

        <form class="space-y-6" @submit.prevent="search">
          <div>
            <label for="identification" class="block text-sm font-semibold text-gray-700">
              Identificación o Alias del Propietario
            </label>
            <div class="mt-1">
              <input
                id="identification"
                type="text"
                v-model="form.identification"
                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                placeholder="Ej: V-12345678 o Apto 4-B"
                required
                autofocus
              />
              <p v-if="form.errors.identification" class="text-red-500 text-xs mt-1">{{ form.errors.identification }}</p>
            </div>
          </div>

          <div>
            <button
              type="submit"
              :disabled="form.processing"
              class="w-full flex justify-center items-center py-2.5 px-4 border border-transparent rounded-md shadow-sm text-sm font-bold text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
            >
              <svg v-if="form.processing" class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Consultar Estado de Cuenta
            </button>
          </div>
        </form>

        <!-- Link to Update Owner Email and Phone (Only for Morochas) -->
        <div v-if="is_morochas" class="mt-6 pt-5 border-t border-gray-200 text-center">
          <p class="text-xs text-gray-500 mb-2">¿Quieres recibir tus recibos digitales por correo?</p>
          <a
            href="/actualizar-datos"
            class="inline-flex items-center text-xs font-bold text-indigo-600 hover:text-indigo-800 bg-indigo-50 hover:bg-indigo-100 px-3 py-1.5 rounded-md transition-colors"
          >
            <svg class="h-4 w-4 mr-1.5 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
            Actualizar Mi Correo Electrónico
          </a>
        </div>
      </div>

      <!-- Support text -->
      <p class="mt-6 text-center text-xs text-gray-500 max-w-sm mx-auto">
        ¿Tienes dudas o no apareces registrado? Comunícate con la administración de tu junta de condominio para validar tu información.
      </p>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Logo from '@/Shared/Logo'

export default {
  components: {
    Head,
    Logo,
  },
  props: {
    logo: String,
    is_morochas: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: this.$inertia.form({
        identification: ''
      }),
    }
  },
  methods: {
    search() {
      if (!this.form.identification) return;
      this.form.post('/findClient');
    },
  },
}
</script>